import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const runRecognizeOrders = unaryRpc({
  name: "runRecognizeOrders",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    started: z.boolean(),
    workflowId: z.string().nullable(),
    message: z.string().optional(),
  }),
});
